// WithLivestreamRating.js
'use strict';
import { connect } from 'react-redux';

import {
  LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE,
  FEATURE_LIVESTREAM_RATING,
  LIVESTREAM_RATING_HIGHLIGHT_THRESHOLD,
} from '../RemoteConfigKeys.js';

import WithRating from '../component/WithRating.jsx';

import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import fetchMeLivestreamRating from '../action/fetchMeLivestreamRating.js';
import fetchLivestreamRatingSummary from '../action/fetchLivestreamRatingSummary.js';

const mapStateToProps = (state, { id: streamId }) => {
  const meId = getMeData(state, 'id');
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const ratedAs = getLiveStreamData(
    state,
    [streamId, 'rating', sessionId],
    'ratedAs'
  );
  const rating = getLiveStreamData(
    state,
    [streamId, 'rating', sessionId],
    'rating'
  );
  const activeStreamId = getOperationData(
    state,
    ['liveStream'],
    'activeStreamId'
  );
  const canFetchData = activeStreamId === streamId;
  return {
    ratingHighlightThreshold: getRemoteConfigData(
      state,
      LIVESTREAM_RATING_HIGHLIGHT_THRESHOLD
    ),
    ratingStepSize: getRemoteConfigData(
      state,
      LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE
    ),
    rating: getLiveStreamData(state, [streamId, 'rating', sessionId], 'rating'),
    ratingCount: getLiveStreamData(
      state,
      [streamId, 'rating', sessionId],
      'ratingCount'
    ),
    isDisplayRatingEnabled:
      getRemoteConfigData(state, FEATURE_LIVESTREAM_RATING) === 1,
    canFetchMeRating:
      canFetchData && meId && ratedAs == null && sessionId != null,
    canFetchRatingSummary: canFetchData && rating == null && sessionId != null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMeRating: ({ id: streamId }) =>
      dispatch(fetchMeLivestreamRating({ streamId })),
    fetchRatingSummary: ({ id: streamId }) =>
      dispatch(fetchLivestreamRatingSummary({ streamId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRating);
